import store from '@/store'
export default [
  {
    path: '/student-healths',
    name: 'student-health',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-health/index.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('infoInquiry/dataBeforeCreate')
      next()
    }
  }
]
